import styled, { keyframes, css } from "styled-components";

const eatAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  15% {
    transform: scale(1.15);
  }
  30% {
    transform: scale(0.95);
  }
  45% {
    transform: scale(1.08);
  }
  60% {
    transform: scale(0.98);
  }
  75% {
    transform: scale(1.03);
  }
  100% {
    transform: scale(1);
  }
`;

const glowPulse = keyframes`
  0%, 100% {
    text-shadow: 0 0 4px rgba(255, 255, 255, 0.3);
    opacity: 1;
  }
  50% {
    text-shadow: 0 0 12px rgba(255, 255, 255, 0.8),
                 0 0 20px rgba(255, 255, 255, 0.5);
    opacity: 1;
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  /* min-height: 64px; */
  width: 100%;
  /* max-width: 1440px; */
  ${({ $inline, $hidden }) =>
    $inline
      ? css`
          position: relative;
          /* Inline variant sits in the page flow — let the body gradient
             show through. */
          background-color: transparent;
        `
      : css`
          position: fixed;
          top: 72px;
          z-index: 101;
          /* Fixed variant floats over scrolling content — translucent blue +
             blur to match the header and blend with the body gradient. */
          background-color: rgba(13, 21, 33, 0.6);
          -webkit-backdrop-filter: blur(14px);
          backdrop-filter: blur(14px);
          transform: ${$hidden ? "translateY(-97px)" : "translateY(0)"};
          transition: transform 0.35s ease-in-out;
        `}
`;

export const TabsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0 16px;
  /* min-height: 64px; */
  overflow-x: auto;
  width: 100%;
`;

export const NavigationItem = styled.div`
  display: flex;
  gap: 2px;
  height: 3rem;
  position: relative;

  a {
    color: #fff;
    font-family: Figtree;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    letter-spacing: -0.1px;
    text-decoration-line: none;
    opacity: 0.5;
    transition: all 0.2s ease;
  }

  a.active {
    font-weight: 600;
    opacity: 1;
  }

  ${(props) =>
    props.$isAnimating &&
    css`
      a p {
        animation:
          ${eatAnimation} 0.6s cubic-bezier(0.36, 0, 0.66, -0.56),
          ${glowPulse} 0.6s ease-out;
        transform-origin: center;
      }
    `}
`;

export const BadgeContainer = styled.div`
  border-radius: 8px;
  border: 0.5px solid #d51e4d;
  background: linear-gradient(90deg, #d51e4d 0%, #ef7d3d 100%);
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6px;
  margin-left: 2px;
  cursor: pointer;
`;

export const BadgeText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: ${(p) => (p.$bold ? "11px" : "9px")};
  font-weight: ${(p) => (p.$bold ? "700" : "500")};
  letter-spacing: ${(p) => (p.$bold ? "-0.055px" : "-0.045px")};
  opacity: ${(p) => (p.$bold ? 1 : 0.75)};
  line-height: normal;
  white-space: nowrap;
`;

export const BannerContainer = styled.h1`
  background: linear-gradient(90deg, #2d78ff 7.04%, #4d9dff 99.38%);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25) inset;
  /* max-width: 1440px; */
  width: 100%;
  padding: 8px 16px;

  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1.68px;
  text-transform: uppercase;

  display: flex;
  justify-content: ${({ $isMobile }) => ($isMobile ? "left" : "center")};
`;
